// removed by extract-text-webpack-plugin
module.exports = {"container":"container__13U9Z","el":"el__2lHHv","boxSpinner":"boxSpinner__17rXO","sk-rotateplane":"sk-rotateplane__3R47n","circleSpinner":"circleSpinner__1G1nb","sk-bouncedelay":"sk-bouncedelay__YGZt5","circleSpinnerBounce1":"circleSpinnerBounce1__2vsBV","circleSpinnerBounce2":"circleSpinnerBounce2__1wSTQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/loading/style.scss
// module id = 279
// module chunks = 0